import React, { useState, useRef, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  VerifyAdharOTPServices,
  SendAdharOTPServices,
} from "../../services/index";
import { useDispatch, useSelector } from "react-redux";
import { setPatientDetails } from "../../redux/slices/abhaSlice";
import { toast } from "react-toastify";
import { timerCount } from "../../config";

const VerifyAdhaOtp = ({
  setAdharOtp,
  setMobileverifyOtp,
  setAdharNumber,
  setIsConfirm1,
  setCurrentStep,
}) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(timerCount);
  const [canResend, setCanResend] = useState(false);
  const [resendCount, setResendCount] = useState(2);
  const [disableResend, setDisableResend] = useState(false);

  const inputRefs = useRef([]);
  const dispatch = useDispatch();
  const mobilemsg = useSelector((state) => state.user.msgAdharmobile);
  const maskedNumber = mobilemsg?.match(/\*{6}\d{4}/)?.[0];

  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      setCanResend(false);
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleInputChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleContinue = async (e) => {
    e.preventDefault();
    const otpValue = otp.join("");
    try {
      const response = await VerifyAdharOTPServices({
        body: {
          referenceId: uuidv4(),
          otpValue,
          txnId: localStorage.getItem("txnId"),
          mobile: "9717661304",
        },
      });

      if (response.status === true) {
        dispatch(setPatientDetails(response.result));
        if (response.result.abhaAddress) {
          localStorage.setItem(
            "preferredAbhaAddress",
            response.result.abhaAddress
          );
        }
        if (response.result.abhaNumber) {
          localStorage.setItem(
            "preferredAbhaNumber",
            response.result.abhaNumber
          );
        }
        if (response.result.xToken) {
          localStorage.setItem("abhaxtoken", response.result.xToken);
        }
        if(response.result){
          localStorage.setItem("aadhaarVerfiUser", JSON.stringify(response.result));
        }
        setCurrentStep("MobileVerificationOTPSend");
      } else {
        let errorMessageRes = "";
        if (response.result?.error?.message.includes(":")) {
          errorMessageRes = response?.result?.error?.message?.split(":")[2];
        }
        const errorMessage =
          errorMessageRes ||
          response?.result?.error?.message ||
          response?.message ||
          "OTP verification failed. Please try again.";
        toast.error(errorMessage);
      }
    } catch (err) {
      console.error("Verification failed", err);
    }
  };

  const handleResendOtp = async () => {
    if (!canResend) return;

    if (resendCount <= 0 || disableResend) {
      setDisableResend(true);
      toast.error("You have reached the maximum resend attempts.");
      return;
    }

    try {
      const aadhaarNumber = localStorage.getItem("aadhaarNumber");
      const body = { aadhaarNumber, resent_count: resendCount };
      const response = await SendAdharOTPServices({ body });

      if (response.status) {
        localStorage.setItem("txnId", response.result.txnId);
        setOtp(["", "", "", "", "", ""]);
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        setResendCount((prev) => {
          const newCount = prev - 1;
          if (newCount <= 0) {
            setDisableResend(true);
            toast.error("You have reached the maximum resend attempts.");
          } else {
            toast.success("OTP resent successfully!");
          }
          return newCount;
        });

        setTimer(timerCount);
      } else {
        toast.error(
          response.data.error.message ||
            response?.message ||
            "Failed to resend OTP."
        );
      }
    } catch (err) {
      console.error("Resend OTP failed", err);
      toast.error("Failed to resend OTP. Please try again.");
    }
  };

  return (
    <section className="container">
      <div className="abha-create-steps">
        <div className="row">
          <div className="col-md-6">
            <div className="create-abha">
              <h2>Create ABHA Number in 3 Steps</h2>
              <p>
                Create ABHA and store all your medical records in one place.
                Take part in the{" "}
                <span className="highlight">
                  Ayushman Bharat Digital Mission (ABDM)
                </span>{" "}
                and get started on your digital health journey.
              </p>

              <div className="vertical-steps">
                <div className="step-item">
                  <div className="step-marker">1</div>
                  <div className="step-content">
                    <h4>Verify Aadhaar Details</h4>
                    <p>
                      Enter your Aadhaar number and verify with OTP received on
                      Aadhaar linked mobile number.
                    </p>
                  </div>
                </div>

                <div className="step-line" />

                <div className="step-item">
                  <div className="step-marker">2</div>
                  <div className="step-content">
                    <h4>Link Mobile Number</h4>
                    <p>
                      Enter your mobile number and verify with OTP to link with
                      ABHA .
                    </p>
                  </div>
                </div>

                <div className="step-line" />

                <div className="step-item">
                  <div className="step-marker">3</div>
                  <div className="step-content">
                    <h4>Create ABHA</h4>
                    <p>Create your ABHA Number with a unique ABHA .</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-card content">
              <h3>Verify Your Aadhaar</h3>
              <p className="pt-3">
                We have sent the OTP to the mobile number ending in{" "}
                {maskedNumber}.
              </p>

              <form className="pt-3" onSubmit={handleContinue}>
                <div className="row otp-box-custom-row">
                  {otp.map((digit, index) => (
                    <div key={index} className="col-2">
                      <input
                        type="text"
                        maxLength="1"
                        value={digit}
                        onChange={(e) => handleInputChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        ref={(el) => (inputRefs.current[index] = el)}
                        autoComplete="off"
                        className="mobile-input otp otp-box-custom"
                      />
                    </div>
                  ))}
                </div>

                <button className="continue-btn" type="submit">
                  Continue to Mobile Verification
                </button>

                <p className="pt-2">
                  Didn’t receive OTP?{" "}
                  {!disableResend && !canResend ? (
                    <span className="resend-timer">Resend in {timer}s</span>
                  ) : (
                    <button
                      type="button"
                      className={`resend-otp btn-link ${
                        disableResend ? "resend-disabled-message" : ""
                      }`}
                      onClick={handleResendOtp}
                      disabled={disableResend}
                    >
                      Resend OTP
                    </button>
                  )}
                </p>

                {!disableResend && resendCount > 0 && (
                  <p className="small resend-message">
                    You have {resendCount} resend attempt
                    {resendCount > 1 ? "s" : ""} left.
                  </p>
                )}
                {disableResend && (
                  <p className="text-danger small">
                    You have no resend attempts left.
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VerifyAdhaOtp;
